/**
 * @description 打点模块
 * @date 2021-09-09 23:48:46
 */

import { $window } from '@umu/umu-dom';

enum STRATEGY_TYPE {
    IMG = 1,
    REPORT = 2,
}
class BaseLogger {
    public strategy: STRATEGY_TYPE;
    constructor(strategy: STRATEGY_TYPE = STRATEGY_TYPE.REPORT) {
        this.strategy = strategy;
    }

    public log(params: Record<string, any>) {
        if (this.strategy === STRATEGY_TYPE.REPORT) {
            this.sendLogByReport(params);
        } else {
            this.sendLogByImg(params);
        }
    }

    private param(obj: Record<string, any>) {
        const params = [];
        for (const key in obj) {
            if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
                params.push(escape(key) + '=' + escape(obj[key] || ''));
            }
        }
        return params.join('&').replace(/%20/g, '+');
    }

    private getLogUrl() {
        let url = 'https://stat.umu.cn/hm.gif';
        url = 'https://stat.umu.co/hm.gif';

        const hostMatch = location.hostname.match(/.*\.(.*?)\.umucdn.cn/);
        const host = (hostMatch && hostMatch[1]) || 'app';
        url = ``;
        // 线下环境增加开关@daoyu @liyue
        if ($window.location.href.indexOf('debug_log=1') > -1) {
            url = `http://stat.${host}.umucdn.cn/hm.gif`;
        } else {
            console.warn('There is not log in offline', new Date().toLocaleTimeString());
        }

        return url;
    }

    private sendLogByImg(params: Record<string, any>) {
        const url = this.getLogUrl();
        if (!url) {
            return;
        }
        let img: HTMLImageElement | null = new Image();
        params.timestamp = new Date().getTime();
        img.src = url + '?' + this.param(params);
        img.onload = () => {
            img = null;
        };
    }

    private sendLogByReport(params: Record<string, any>) {
        if (!$window.BJ_REPORT || !$window.BJ_REPORT.report) {
            return;
        }
        $window.BJ_REPORT.report(params);
    }
}

const baseLogger = new BaseLogger();

export { baseLogger, BaseLogger, STRATEGY_TYPE };
